/* ============================================================
   HANLABAN CRO THEME — theme.js
   Handles: Cart drawer, mobile nav, quick view, email popup,
   product gallery, quantity selectors, variant switching.
   ============================================================ */

(function() {
  'use strict';

  // --- Utility ---
  function $(selector, context) { return (context || document).querySelector(selector); }
  function $$(selector, context) { return Array.from((context || document).querySelectorAll(selector)); }
  function on(el, event, handler) { if (el) el.addEventListener(event, handler); }
  function delegate(parent, selector, event, handler) {
    on(parent, event, function(e) {
      var target = e.target.closest(selector);
      if (target && parent.contains(target)) handler.call(target, e);
    });
  }
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // --- Cart Drawer ---
  var cartDrawer = $('#CartDrawer');
  function openCart() { if (cartDrawer) cartDrawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeCart() { if (cartDrawer) cartDrawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  delegate(document, '[data-action="open-cart"]', 'click', openCart);
  delegate(document, '[data-action="close-cart"]', 'click', closeCart);

  // Cart AJAX operations
  function updateCartDrawer() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        $$('[data-cart-count]').forEach(function(el) { el.textContent = cart.item_count; });
        // Refresh the cart drawer section
        fetch('/?section_id=cart-drawer')
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var temp = document.createElement('div');
            temp.innerHTML = html;
            var newDrawer = temp.querySelector('.cart-drawer');
            if (newDrawer && cartDrawer) {
              cartDrawer.innerHTML = newDrawer.innerHTML;
              cartDrawer.setAttribute('aria-hidden', 'false');
              document.body.style.overflow = 'hidden';
            }
          });
      });
  }

  // Add to cart (from product cards)
  delegate(document, '.product-card__atc-form', 'submit', function(e) {
    e.preventDefault();
    var formData = new FormData(this);
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function(r) { return r.json(); })
      .then(function() { updateCartDrawer(); });
  });

  // Quantity changes in cart drawer
  delegate(document, '[data-action="increase-qty"]', 'click', function() {
    var line = this.getAttribute('data-line');
    changeCartQty(line, 1);
  });
  delegate(document, '[data-action="decrease-qty"]', 'click', function() {
    var line = this.getAttribute('data-line');
    changeCartQty(line, -1);
  });
  delegate(document, '[data-action="remove-item"]', 'click', function() {
    var line = this.getAttribute('data-line');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line), quantity: 0 })
    }).then(function() { updateCartDrawer(); });
  });

  function changeCartQty(line, delta) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var item = cart.items[parseInt(line) - 1];
        if (!item) return;
        var newQty = Math.max(0, item.quantity + delta);
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line), quantity: newQty })
        });
      })
      .then(function() { updateCartDrawer(); });
  }

  // --- Mobile Navigation ---
  var mobileNav = $('#MobileNav');
  function openMobileMenu() { if (mobileNav) mobileNav.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeMobileMenu() { if (mobileNav) mobileNav.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  delegate(document, '[data-action="open-mobile-menu"]', 'click', openMobileMenu);
  delegate(document, '[data-action="close-mobile-menu"]', 'click', closeMobileMenu);

  // --- Quick View ---
  var quickView = $('#QuickView');
  var quickViewContent = $('#QuickViewContent');

  delegate(document, '[data-action="quick-view"]', 'click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var handle = this.getAttribute('data-product-handle');
    if (!handle || !quickView) return;

    quickView.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    quickViewContent.innerHTML = '<div class="quick-view__loading"><div class="spinner"></div></div>';

    fetch('/products/' + handle + '?view=quick-view')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        quickViewContent.innerHTML = html;

        // Dispatch event so swatch colors get painted immediately by theme-fixes.js
        document.dispatchEvent(new CustomEvent('cards:rendered', { detail: { root: quickViewContent } }));

        var form = quickViewContent.querySelector('.quick-view__form');
        var variants = JSON.parse(form.getAttribute('data-qv-variants-json'));
        var variantInput = form.querySelector('[data-qv-variant-input]');
        var atcBtn = form.querySelector('[data-qv-atc]');
        var mainImg = quickViewContent.querySelector('[data-qv-featured-image]');
        var priceCurrent = quickViewContent.querySelector('[data-qv-price]');
        var priceCompare = quickViewContent.querySelector('[data-qv-compare-price]');

        // 1. Swatches & options inputs selection
        quickViewContent.querySelectorAll('[data-qv-option-input]').forEach(function(input) {
          input.addEventListener('change', function() {
            // Update active styling classes
            var container = this.closest('.product-option__swatches, .product-option__buttons');
            if (container) {
              container.querySelectorAll('.color-swatch, .option-btn').forEach(function(el) {
                el.classList.remove('color-swatch--active', 'option-btn--active');
              });
              this.closest('.color-swatch, .option-btn').classList.add(
                this.closest('.color-swatch') ? 'color-swatch--active' : 'option-btn--active'
              );
            }

            // Find matching variant
            var selected = [];
            quickViewContent.querySelectorAll('[data-qv-option-index]').forEach(function(optContainer) {
              var checked = optContainer.querySelector('[data-qv-option-input]:checked');
              if (checked) selected.push(checked.value);
            });

            var match = variants.find(function(v) {
              return v.options.every(function(opt, i) { return opt === selected[i]; });
            });

            if (match) {
              variantInput.value = match.id;
              if (match.available) {
                atcBtn.disabled = false;
                atcBtn.textContent = 'Add to Cart — ' + formatMoney(match.price);
              } else {
                atcBtn.disabled = true;
                atcBtn.textContent = 'Sold Out';
              }

              // Update prices
              priceCurrent.textContent = formatMoney(match.price);
              if (priceCompare) {
                if (match.compare_at_price && match.compare_at_price > match.price) {
                  priceCompare.style.display = '';
                  priceCompare.textContent = formatMoney(match.compare_at_price);
                } else {
                  priceCompare.style.display = 'none';
                }
              }
            } else {
              atcBtn.disabled = true;
              atcBtn.textContent = 'Unavailable';
            }

            // If it's color swatch, also swap main gallery preview image if image exists
            var isColor = this.closest('.color-swatch');
            if (isColor) {
              var swatchDot = isColor.querySelector('.color-swatch__dot');
              var newImgSrc = swatchDot ? swatchDot.getAttribute('data-image') : null;
              if (mainImg && newImgSrc) {
                mainImg.src = newImgSrc;
                // remove thumbnail active class when main image swaps via swatch
                quickViewContent.querySelectorAll('.quick-view__gallery-thumb').forEach(function(t) {
                  t.classList.remove('is-active');
                });
              }
            }
          });
        });

        // 2. Thumbnails toggle click
        quickViewContent.querySelectorAll('[data-qv-thumb-url]').forEach(function(thumbBtn) {
          thumbBtn.addEventListener('click', function(e) {
            e.preventDefault();
            var targetUrl = this.getAttribute('data-qv-thumb-url');
            if (mainImg && targetUrl) {
              mainImg.src = targetUrl;
            }
            quickViewContent.querySelectorAll('.quick-view__gallery-thumb').forEach(function(t) {
              t.classList.remove('is-active');
            });
            this.classList.add('is-active');
          });
        });

        // 3. Quantity Selector Actions
        var qtyInput = form.querySelector('[data-qv-qty-input]');
        delegate(form, '[data-qv-action="increase"]', 'click', function(e) {
          e.preventDefault();
          if (qtyInput) qtyInput.value = Math.min(10, parseInt(qtyInput.value) + 1);
        });
        delegate(form, '[data-qv-action="decrease"]', 'click', function(e) {
          e.preventDefault();
          if (qtyInput) qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1);
        });

        // 4. Form AJAX Add to Cart
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          var fd = new FormData(this);
          atcBtn.disabled = true;
          atcBtn.textContent = 'Adding…';
          fetch('/cart/add.js', { method: 'POST', body: fd })
            .then(function(r) { return r.json(); })
            .then(function() {
              closeQuickView();
              updateCartDrawer();
            })
            .catch(function() {
              atcBtn.disabled = false;
              atcBtn.textContent = 'Try Again';
            });
        });

      });
  });

  function closeQuickView() { if (quickView) { quickView.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }
  delegate(document, '[data-action="close-quick-view"]', 'click', closeQuickView);

  // --- Email Popup ---
  var emailPopup = $('#EmailPopup');
  if (emailPopup) {
    var delay = parseInt(emailPopup.getAttribute('data-delay') || '8') * 1000;
    var dismissed = localStorage.getItem('hanlaban_popup_dismissed');
    if (!dismissed) {
      setTimeout(function() {
        emailPopup.setAttribute('aria-hidden', 'false');
      }, delay);
    }
  }
  delegate(document, '[data-action="close-popup"]', 'click', function() {
    if (emailPopup) {
      emailPopup.setAttribute('aria-hidden', 'true');
      localStorage.setItem('hanlaban_popup_dismissed', '1');
    }
  });

  // --- Product Gallery ---
  delegate(document, '.product-gallery__thumb', 'click', function() {
    var index = this.getAttribute('data-index');
    var gallery = this.closest('.product-gallery');
    if (!gallery) return;
    gallery.querySelectorAll('.product-gallery__slide').forEach(function(s) { s.classList.remove('product-gallery__slide--active'); });
    gallery.querySelectorAll('.product-gallery__thumb').forEach(function(t) { t.classList.remove('product-gallery__thumb--active'); });
    var slide = gallery.querySelector('.product-gallery__slide[data-index="' + index + '"]');
    if (slide) slide.classList.add('product-gallery__slide--active');
    this.classList.add('product-gallery__thumb--active');
  });

  // --- Product Page Quantity ---
  delegate(document, '[data-action="increase-product-qty"]', 'click', function() {
    var input = $('#ProductQuantity');
    if (input) input.value = Math.min(10, parseInt(input.value) + 1);
  });
  delegate(document, '[data-action="decrease-product-qty"]', 'click', function() {
    var input = $('#ProductQuantity');
    if (input) input.value = Math.max(1, parseInt(input.value) - 1);
  });

  // --- Product Variant Selection ---
  delegate(document, '.product-info .color-swatch input, .product-info .option-btn input', 'change', function() {
    // Update active states
    var container = this.closest('.product-option__swatches, .product-option__buttons');
    if (container) {
      container.querySelectorAll('.color-swatch, .option-btn').forEach(function(el) {
        el.classList.remove('color-swatch--active', 'option-btn--active');
      });
      this.closest('.color-swatch, .option-btn').classList.add(
        this.closest('.color-swatch') ? 'color-swatch--active' : 'option-btn--active'
      );
    }
  });

  // --- Product Page ATC form (AJAX) ---
  delegate(document, '.product-atc', 'click', function(e) {
    var form = this.closest('form');
    if (!form) return;
    var bundleRoot = form.querySelector('[data-bundle-tiers]');
    if (bundleRoot) {
      var selectedTier = bundleRoot.querySelector('.bundle-tier-v2.is-selected');
      var tierNum = selectedTier ? parseInt(selectedTier.getAttribute('data-tier'), 10) : 1;
      if (tierNum > 1) return;
    }
    e.preventDefault();
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function(r) { return r.json(); })
      .then(function() { updateCartDrawer(); });
  });

  // --- Customer Login Toggle ---
  on($('#RecoverLink'), 'click', function(e) {
    e.preventDefault();
    var loginForm = this.closest('form').parentElement;
    var recoverForm = $('#RecoverForm');
    if (loginForm && recoverForm) {
      loginForm.querySelector('form').style.display = 'none';
      this.closest('.customer-auth__links').style.display = 'none';
      recoverForm.style.display = 'block';
    }
  });
  on($('#HideRecoverLink'), 'click', function(e) {
    e.preventDefault();
    var recoverForm = $('#RecoverForm');
    if (recoverForm) {
      recoverForm.style.display = 'none';
      var card = recoverForm.closest('.customer-auth__card');
      if (card) {
        card.querySelector('form').style.display = 'block';
        card.querySelector('.customer-auth__links').style.display = 'flex';
      }
    }
  });

  // --- Sort Collection ---
  delegate(document, '[data-action="sort-collection"]', 'change', function() {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    window.location.href = url.toString();
  });

  // --- Product Recommendations (Shopify API) ---
  var recsSection = $('[data-product-id].product-recommendations');
  if (recsSection) {
    var productId = recsSection.getAttribute('data-product-id');
    var sectionId = recsSection.getAttribute('data-section-id');
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.products && data.products.length > 0) {
          fetch('/recommendations/products?product_id=' + productId + '&limit=4&section_id=' + sectionId)
            .then(function(r) { return r.text(); })
            .then(function(html) {
              var temp = document.createElement('div');
              temp.innerHTML = html;
              var grid = temp.querySelector('.product-grid');
              var target = recsSection.querySelector('.product-grid');
              if (grid && target) target.innerHTML = grid.innerHTML;
            });
        }
      });
  }

  // --- Quick View CSS (injected) ---
  var qvStyle = document.createElement('style');
  qvStyle.textContent = '.quick-view__grid{display:grid;gap:1.5rem;}@media(min-width:768px){.quick-view__grid{grid-template-columns:1fr 1fr;}}.quick-view__image img{width:100%;aspect-ratio:3/4;object-fit:cover;}.quick-view__info{display:flex;flex-direction:column;gap:1rem;}.quick-view__full-link{font-size:0.8125rem;color:#b8943e;margin-top:auto;}';
  document.head.appendChild(qvStyle);

  /* ============================================================
     PRODUCT CARD v2 — hover image scroller + inline size/ATC
     ============================================================ */
  function initScroller(card) {
    var track = card.querySelector('[data-scroller-track]');
    if (!track) return;
    var slides = track.children;
    var total = slides.length;
    if (total <= 1) return;
    var dots = card.querySelectorAll('[data-scroller-dot]');
    var prev = card.querySelector('[data-scroller-prev]');
    var next = card.querySelector('[data-scroller-next]');
    var index = 0;

    function go(i) {
      index = (i + total) % total;
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === index);
      }
    }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(index - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(index + 1); });
    for (var d = 0; d < dots.length; d++) {
      (function (n) {
        dots[n].addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(n); });
        dots[n].addEventListener('mouseenter', function () { go(n); });
      })(d);
    }
    // Reset to first image when the cursor leaves the card
    card.addEventListener('mouseleave', function () { go(0); });
  }

  function initInlineBuy(card) {
    var sizeBtns = card.querySelectorAll('[data-card-size]');
    var atc = card.querySelector('[data-card-atc]');
    var input = card.querySelector('[data-card-variant-input]');
    var form = card.querySelector('[data-card-atc-form]');
    if (!form) return;

    if (sizeBtns.length && atc && input) {
      for (var i = 0; i < sizeBtns.length; i++) {
        (function (btn) {
          if (btn.disabled) return;
          btn.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            for (var j = 0; j < sizeBtns.length; j++) sizeBtns[j].classList.remove('is-selected');
            btn.classList.add('is-selected');
            input.value = btn.getAttribute('data-variant-id');
            atc.disabled = false;
            atc.textContent = 'Add to Cart';
          });
        })(sizeBtns[i]);
      }
    }

    // AJAX add to cart so the customer never leaves the grid
    form.addEventListener('submit', function (e) {
      var id = form.querySelector('input[name="id"]').value;
      if (!id) { e.preventDefault(); return; }
      e.preventDefault();
      if (atc) { atc.textContent = 'Adding…'; atc.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (atc) { atc.textContent = 'Added ✓'; }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          // open cart drawer if present
          var openCart = document.querySelector('[data-action="open-cart"]');
          if (openCart) openCart.click();
          setTimeout(function () { if (atc) { atc.textContent = 'Add to Cart'; atc.disabled = false; } }, 1800);
        })
        .catch(function () { if (atc) { atc.textContent = 'Try Again'; atc.disabled = false; } });
    });
  }

  function initCards(root) {
    var cards = (root || document).querySelectorAll('.product-card[data-product-handle]');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].__cardInit) continue;
      cards[i].__cardInit = true;
      initScroller(cards[i]);
      initInlineBuy(cards[i]);
    }
  }

  // --- Quick Shop Drawer ---
  var quickShop = $('#QuickShopDrawer');
  var quickShopContent = $('#QuickShopContent');

  function openQuickShop() { if (quickShop) { quickShop.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } }
  function closeQuickShop() { if (quickShop) { quickShop.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }

  delegate(document, '[data-action="quick-shop"]', 'click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log("Quick Shop clicked!");
    var handle = this.getAttribute('data-product-handle');
    console.log("Product handle:", handle);
    console.log("Quick shop drawer element:", quickShop);
    console.log("Quick shop content element:", quickShopContent);
    if (!handle || !quickShop) return;

    console.log("Opening Quick Shop!");
    openQuickShop();
    quickShopContent.innerHTML = '<div class="quick-view__loading"><div class="spinner"></div></div>';

    fetch('/products/' + handle + '?view=quick-shop')
      .then(function(r) { 
        if (!r.ok) {
          throw new Error('Failed to load product');
        }
        return r.text(); 
      })
      .then(function(html) {
        quickShopContent.innerHTML = html;

        // Color swatches painted by theme-fixes.js
        document.dispatchEvent(new CustomEvent('cards:rendered', { detail: { root: quickShopContent } }));

        var form = quickShopContent.querySelector('.quick-shop__form');
        if (!form) {
          closeQuickShop();
          return;
        }
        var variantsJson = form.getAttribute('data-qs-variants-json');
        var variants = [];
        try {
          variants = JSON.parse(variantsJson);
        } catch (err) {
          console.error('Failed to parse variants:', err);
        }
        var variantInput = form.querySelector('[data-qs-variant-input]');
        var atcBtn = form.querySelector('[data-qs-atc]');
        var previewImg = quickShopContent.querySelector('[data-qs-preview-image]');
        var priceCurrent = quickShopContent.querySelector('[data-qs-price]');
        var priceCompare = quickShopContent.querySelector('[data-qs-compare-price]');

        quickShopContent.querySelectorAll('[data-qs-option-input]').forEach(function(input) {
          input.addEventListener('change', function() {
            var container = this.closest('.product-option__swatches, .product-option__buttons');
            if (container) {
              container.querySelectorAll('.color-swatch, .option-btn').forEach(function(el) {
                el.classList.remove('color-swatch--active', 'option-btn--active');
              });
              this.closest('.color-swatch, .option-btn').classList.add(
                this.closest('.color-swatch') ? 'color-swatch--active' : 'option-btn--active'
              );
            }

            var isColor = this.closest('.color-swatch');
            if (isColor) {
              var swatchDot = isColor.querySelector('.color-swatch__dot');
              var newImgSrc = swatchDot ? swatchDot.getAttribute('data-image') : null;
              if (previewImg && newImgSrc) {
                previewImg.src = newImgSrc;
              }
            }

            var selected = [];
            var optionContainers = quickShopContent.querySelectorAll('.product-option');
            var allSelected = true;
            var unselectedOptionNames = [];

            optionContainers.forEach(function(optContainer) {
              var checkedInput = optContainer.querySelector('[data-qs-option-input]:checked');
              if (checkedInput) {
                selected.push(checkedInput.value);
              } else {
                allSelected = false;
                var label = optContainer.querySelector('.product-option__label');
                if (label) {
                  unselectedOptionNames.push(label.textContent.trim());
                } else {
                  unselectedOptionNames.push('Option');
                }
              }
            });

            if (!allSelected) {
              atcBtn.disabled = true;
              atcBtn.textContent = 'Select ' + unselectedOptionNames.join(' & ');
              return;
            }

            var match = variants.find(function(v) {
              return v.options.every(function(opt, i) { return opt === selected[i]; });
            });

            if (match) {
              variantInput.value = match.id;
              if (match.available) {
                atcBtn.disabled = false;
                atcBtn.textContent = 'Add to Cart — ' + formatMoney(match.price);
              } else {
                atcBtn.disabled = true;
                atcBtn.textContent = 'Sold Out';
              }
              priceCurrent.textContent = formatMoney(match.price);
              if (priceCompare) {
                if (match.compare_at_price && match.compare_at_price > match.price) {
                  priceCompare.style.display = '';
                  priceCompare.textContent = formatMoney(match.compare_at_price);
                } else {
                  priceCompare.style.display = 'none';
                }
              }
            } else {
              atcBtn.disabled = true;
              atcBtn.textContent = 'Unavailable';
            }
          });
        });

        form.addEventListener('submit', function(e) {
          e.preventDefault();
          var fd = new FormData(this);
          atcBtn.disabled = true;
          atcBtn.textContent = 'Adding…';
          fetch('/cart/add.js', { method: 'POST', body: fd })
            .then(function(r) { 
              if (!r.ok) throw new Error('Failed to add to cart'); 
              return r.json(); 
            })
            .then(function() {
              closeQuickShop();
              updateCartDrawer();
            })
            .catch(function() {
              atcBtn.disabled = false;
              atcBtn.textContent = 'Try Again';
            });
        });
      })
      .catch(function(err) {
        console.error('Quick shop failed:', err);
        quickShopContent.innerHTML = '<p style="padding: 2rem; text-align: center;">Failed to load product. Please try again.</p>';
      });
  });

  delegate(document, '[data-action="close-quick-shop"]', 'click', closeQuickShop);

  if (document.readyState !== 'loading') initCards();
  else document.addEventListener('DOMContentLoaded', function () { initCards(); });

  // Re-init cards injected later (recommendations rails, recently viewed)
  document.addEventListener('cards:rendered', function (e) { initCards(e.detail && e.detail.root); });
})();
